<template>
  <div v-if="bannerPlaceHolderForNewExclusiveRevamp && page === 'exclusive'">
    <div v-if="isDesktop"  >
      <div style="justify-content: center;" class="row" :class="page">
        <div
          v-for="(item, index) in membershipData && membershipData.ex_banner" :key="index"
          class="newCardWrapper mb-2"
          :class="{'active-new': selectedMembership === item.membership_id, 'card': true, 'text-center': true}"
          :style= "[selectedMembership === item.membership_id ? card_active : card_inactive]"
          @click="selectExclusive(item.membership_id, index)"
        >
          <div :class="item.banner_title ? 'popular' : 'popular invisible'">
            <h5 class="popular-main-new" :style="popular_head">{{item.banner_title}}</h5>
          </div>

          <div class="title-new">
            <h5 class="title-main mt-2 fsemibold">{{item.duration}}</h5>
          </div>
          <div class="price-new mt-3 fbold">
            <h6>
              <span class="">({{ currencySymbol }} {{item.price}}/</span>
              <span class="">Month)</span>
            </h6>
          </div>
          <div class="membership-price-new mt-5 fsemibold">
            {{ currencySymbol }} {{item.total_price}}
          </div>
          <div class="ex-saving-new">
            <h4 class="saving-price fbold">Save {{item.discount}}</h4>
          </div>
        </div>
      </div>
      <div class="exc-add-btn-wrapper">
        <button class="add-cart-btn btn pointer souledButton" :style="add_to_cart_btn" @click="triggerAddMembership()">Add Membership to Cart </button>
      </div>
      <div class="exc-modal-footer" v-if="!page" @click="togglePopupBox">
        No, I want to continue paying full price
      </div>
    </div>
    <div v-else >
      <div class="newCardWrapper-mobile d-flex flex-column" style="align-items: center;" >
        <div
          v-for="(item, index) in membershipData && membershipData.ex_banner.slice(0, 1)" :key="index"
          class="col-11 yearly-plan plan-rad mb-3"
          :class="selectedMembership === item.membership_id ? 'exc-plan-comp2' : 'exc-plan-comp'"
          @click="selectMembershipPlanHandler(item.membership_id, index)"
        >
          <svg v-if="item.banner_title" xmlns="http://www.w3.org/2000/svg" 
          style="position: absolute;top: 0;left: 0;" 
          width="72.645" height="16.138" viewBox="0 0 72.645 16.138">
              <path fill="#161b24" stroke="#fff"
              stroke-width="1.2px"
              d="M1729.292 5515.277c0 .336-7.458 6.389-7.458 6.389s6.151 6.9 7.615 8.392h-70.615v-14.781s70.458-.336 70.458 0z"
              transform="translate(-1658.234 -5514.521)">
              </path>
              <text x="4" y="10" style="fill: #fff;font-size: 0.5rem;font-style: italic;font-weight: 600;">{{item.banner_title}}</text>
          </svg>
          <div class="row pt-2 pb-2 font-weight-bold">
            <div class="col-1 ml-2 pt-2">
              <label>
                <input type="radio" :checked="selectedMembership === item.membership_id" name="excRadio" />
                <span></span>
              </label>
            </div>
            <div class="col d-flex mt-2">
              <div class="col-5 text-left" style="line-height: 1.2;">
                <span class= "align-middle" style="font-size: 0.8rem;">{{item.duration}}</span><br>
                <span class= "" style="font-size: 0.7rem;">({{ currencySymbol }} {{item.price}}/Month)</span>
              </div>
              <div class="col text-center pt-1">
                <span class= "align-middle" style="font-size: 0.7rem;font-style: italic;">Save {{item.discount}}</span>
              </div>
              <div class="col text-right">
                <span class= "align-middle" style="font-size: 1.35rem;">{{ currencySymbol }} {{item.total_price}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="collapse pb-2 colPaddingHiden" id="collapseOffers" role="tabpanel" aria-labelledby="offerSise">
          <div class="d-flex flex-column" style="align-items: center;">
            <div
              v-for="(item, index) in membershipData && membershipData.ex_banner.slice(1)" :key="index"
              class="col-12 yearly-plan plan-rad mb-3"
              :class="selectedMembership === item.membership_id ? 'exc-plan-comp2' : 'exc-plan-comp'"
              @click="selectMembershipPlanHandler(item.membership_id, index)"
            >
             <svg v-if="item.banner_title" xmlns="http://www.w3.org/2000/svg" 
              style="position: absolute;top: 0;left: 0;" 
              width="72.645" height="16.138" viewBox="0 0 72.645 16.138">
                <path fill="#161b24" stroke="#fff"
                  stroke-width="1.2px"
                  d="M1729.292 5515.277c0 .336-7.458 6.389-7.458 6.389s6.151 6.9 7.615 8.392h-70.615v-14.781s70.458-.336 70.458 0z"
                  transform="translate(-1658.234 -5514.521)">
                </path>
                <text x="4" y="10" style="fill: #fff;font-size: 0.5rem;font-style: italic;font-weight: 600;">{{item.banner_title}}</text>
              </svg>
            <div class="row pt-2 pb-2 font-weight-bold">
              <div class="col-1 ml-2 pt-2">
                <label>
                  <input type="radio" :checked="selectedMembership === item.membership_id" name="excRadio" />
                  <span></span>
                </label>
              </div>
              <div class="col d-flex mt-2">
                <div class="col-5 text-left" style="line-height: 1.2;">
                  <span class= "align-middle" style="font-size: 0.8rem;">{{item.duration}}</span><br>
                  <span class= "" style="font-size: 0.7rem;">({{ currencySymbol }} {{item.price}}/Month)</span>
                </div>
                <div class="col text-center pt-1">
                  <span class= "align-middle" style="font-size: 0.7rem;font-style: italic;">Save {{item.discount}}</span>
                </div>
                <div class="col text-right">
                  <span class= "align-middle" style="font-size: 1.35rem;">{{ currencySymbol }} {{item.total_price}}</span>
                </div>
              </div>
          </div>
            </div>
          </div>
        </div>
        <div class="col-12 pb-2" id="offerSise" role="tablist" v-if="membershipData && membershipData.ex_banner && membershipData.ex_banner.length > 1">
          <div role="tab" class="mb-0 pr-2 accordianheading collapsepadding" id="showOffers" data-toggle="collapse" data-parent="#offerSise" href="#collapseOffers" aria-expanded="false" aria-controls="collapseOffers">
            <label for=""
            style="cursor:pointer;
            color: #161b24;
            font-size: 0.7rem;
            text-decoration: underline;
            font-family: 'Source Sans Pro semibold', sans-serif;
            font-weight: 600;
            letter-spacing: normal;
            "
            class=" pt-3 f16">View More plans</label>
            <i style="cursor:pointer;color: #161b24;" class="fa fa-angle-down" aria-hidden="true"></i>
          </div>
        </div>
      </div>
       <exclusiveAddTOCart :excButtonText="excButtonText" :addExclusiveMem="triggerAddMembership" :excCartDataItem="changeExcProduct" v-if="!isExclusive"></exclusiveAddTOCart>
    </div>
  </div>
  <div v-else>
    <div style="justify-content: center;" class="row" :class="page">
      <div
        class="mb-3"
        v-for="(item, index) in membershipData && membershipData.ex_banner" :key="index"
        :class="{'active': selectedMembership === item.membership_id, 'card': true, 'text-center': true}"
        :style= "[selectedMembership === item.membership_id ? card_active : card_inactive]"
        @click="selectExclusive(item.membership_id, index)"
      >
        <div :class="item.banner_title ? 'popular' : 'popular invisible'">
          <h5 class="popular-main" :style="popular_head">{{item.banner_title}}</h5>
        </div>

        <div class="title">
          <h5 class="title-main fsemibold ex-title-grey">{{item.duration}}</h5>
        </div>
        <div class="price fbold">
          <h4>
            <span class="price-amount">{{ currencySymbol }} {{item.price}}/</span>
            <span class="month">Month</span>
          </h4>
        </div>
        <div class="membership-price fsemibold">
          {{ currencySymbol }} {{item.total_price}}
        </div>
        <div class="ex-saving">
          <h4 class="saving-price fbold">Save {{item.discount}}</h4>
        </div>
      </div>
    </div>
    <div class="exc-add-btn-wrapper">
      <button class="add-cart-btn btn pointer souledButton" :style="add_to_cart_btn" @click="triggerAddMembership()">Add to Cart </button>
    </div>
    <div class="exc-modal-footer" v-if="!page" @click="togglePopupBox">
      No, I want to continue paying full price
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import exclusiveAddTOCart from './exclusiveAddToCart.vue'
  export default {
    data () {
      return {
        selectedMembership: '',
        changeExcProduct: null,
        excButtonText: ''
      }
    },
    components: {exclusiveAddTOCart},
    props: ['addExclusiveMem', 'ADD_MEMBERSHIP_TO_CART', 'title_content', 'popular_head', 'card_inactive', 'card_active', 'add_to_cart_btn', 'page', 'togglePopup', 'isDesktop'],
    computed: {
      ...mapGetters(['bannerPlcaeHolderData', 'isExclusive', 'get_exclusive_user', 'authStatus', 'currencySymbol', 'membershipData']),
      bannerPlaceHolderForNewExclusiveRevamp: function () {
        const isExclusiveRevampObj = this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'EXCLUSIVE_REVAMP_NEW'.toLowerCase())
        if (isExclusiveRevampObj) {
          return true
        }
        return null
      }
    },
    methods: {
      selectExclusive (excMem, index) {
        this.selectedMembership = excMem
      },
      triggerAddMembership () {
        this.addExclusiveMem(this.selectedMembership)
        // this.ADD_MEMBERSHIP_TO_CART(this.selectedMembership)
        let memPlan = this.getSelectedMemPlanDetails(this.selectedMembership)
        this.$store.dispatch('TATVIC_EVENT', {eventName: 'ADD_MEMBERSHIP_TO_CART',
          payload: {
            SUBSCRIPTION_PLAN: memPlan.plan,
            AMOUNT: memPlan.amount,
            exclusive_tracker: this.$route.path
          }}
        )
        this.$store.commit('GTAG_EVENT', {eventName: 'exc_membership_added_discount_price', payload: {exclusive_tracker: this.$route.path}})
        if (this.page !== 'exclusive') {
          this.$store.commit('MEMBERSHIP_MANUALLY_ADDED', true)
        }
      },
      togglePopupBox () {
        this.$store.commit('GTAG_EVENT', {eventName: 'without_exclusive_membership_shopping', payload: {}})
        this.togglePopup()
      },
      updateExcPlan (excProd, prodType) {
        if (excProd && (prodType || prodType === 0)) {
          this.selectExclusive(excProd, prodType)
        }
        this.changeExcProduct = excProd
        this.excButtonText = 'Add Membership to Cart'
      },
      selectMembershipPlanHandler (excProd, prodType) {
        this.updateExcPlan(excProd, prodType)
      },
      getSelectedMemPlanDetails (planId) {
        const selectedPlan = this.membershipData.ex_banner.filter((item) => item.membership_id === planId)
        if (selectedPlan && selectedPlan.length) {
          return {plan: selectedPlan[0].duration, amount: selectedPlan[0].total_price}
        }
        return {}
      }
    },
    mounted () {
      this.$store.dispatch('GET_MEMBERSHIP_DATA')
      this.selectedMembership = this.membershipData && this.membershipData.ex_banner.length && this.membershipData.ex_banner[0].membership_id // initially select most popular membership
      this.selectMembershipPlanHandler(this.selectedMembership, 2)
    },
    watch: {
      'membershipData' () {
        this.selectedMembership = this.membershipData && this.membershipData.ex_banner.length && this.membershipData.ex_banner[0].membership_id // initially select most popular membership

        this.changeExcProduct = this.selectedMembership
        this.excButtonText = 'Add Membership to Cart'
      }
    }
  }
</script>

<style scoped>
  .card{
    margin: 5px;
    background: transparent;
    position: relative;
    width: 30%;
    box-shadow:
    0 4px 2.2px rgba(0, 0, 0, 0.034),
    0 4px 10px rgba(0, 0, 0, 0.086),
    0 4px 20px rgba(0, 0, 0, 0.12);
    -webkit-transition: .1s;
    transition: .1s;
  }
  .newCardWrapper {
    width:300px !important;
    height:256px !important;
  }
  .card:hover{
    cursor: pointer;
  }

  .active {
    border: 2px #1a1f29 solid;
    background-color: #FFF;
  }
  .active-new {
    border: 2px #707070 solid;
    background-color: #FFF;
  }

  .title{
    left: 0;
    right: 0;
    margin: auto;
  }

  .popular-main {
    color: #ffffff;
    font-weight: bold;
    font-size: 16px;
    padding: 8px;
    margin-top: -1px;
    background-color: #1a1f29;
    -webkit-transform: scale(1.01);
      transform: scale(1.01);
  }
  .popular-main-new {
    color: #ffffff;
    font-weight: bold;
    font-size: 15px;
    padding: 8px;
    margin-top: -1px;
    background-color: #e76a52;
    letter-spacing: normal;
  }

  .month {
    font-size: 12px;
    margin-bottom: 2px;
  }

  .membership-border {
    margin-top:2px;
    margin-bottom: 5px;
    width: 80%;
    background: #D3D3D3;
  }
  
  .price{
    left: 0;
    right: 0;
    margin: auto;
  }

  .title h5 {
    margin-bottom: 5px;
    font-size: 21px;
  }
  .title-new h5 {
    margin-bottom: 5px;
    font-size: 26px;
    color: #161b24;
    letter-spacing: normal;
  }

  .price h4 {
    margin: 0;
    color: #646769;
    font-size: 19px;
    font-weight: bold;
    font-family: 'Source Sans Pro', sans-serif;
  font-weight: 600;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    z-index: 2;
  }
  .price-new h6 {
    margin: 0;
    color: #161b24;
    font-size: 18px;
    font-family: 'Source Sans Pro', sans-serif;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    z-index: 2;
    letter-spacing: normal;
  }

  .price h4 .modal-price-amount {
    color: rgb(88, 89, 91);
  }

  .exc-original-price {
    color: #646768;
    left: 0;
    right: 0;
    margin: auto;
  }

  .exc-original-price .og-price {
    font-size: 18px;
  }

  .membership-price {
    left: 0;
    right: 0;
    margin: auto;
    font-size: 30px;
    color: #e76a52;
    font-family: 'Source Sans Pro', sans-serif;
  font-weight: 700;
    font-weight: bold;
  }
  .membership-price-new {
    left: 0;
    right: 0;
    font-size: 26px;
    color:#161b24;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 700;
    font-weight: bold;
    letter-spacing: normal;
  }
  .ex-saving {
    color: #3ABDAF;
    left: 0;
    right: 0;
    margin: auto;
  }

  .ex-saving .saving-price {
    font-size: 15px;
    font-weight: bold;
  }
  .ex-saving-new {
    color: #148c8d;
    letter-spacing: normal;
    left: 0;
    right: 0;
    margin: auto;
  }

  .ex-saving-new .saving-price {
    font-size: 14px;
    font-weight: bold;
    font-style: italic;
    letter-spacing: normal;
  }
  .add-cart-btn {
    background: #E66A51;
    border-color: #E66A51;
    letter-spacing: 1px;
    margin: 0 auto;
    font-size: 20px;
    font-weight: bold;
  }

  .add-cart-btn:hover {
    color: #ffffff !important;
    background: #ee622c;
    border-color: #ee622c;
  }

  .btn {
    margin-bottom: 15px;
  }

  .bigDiscounts {
    color: #E66A51;
    font-size: 18px;
    text-align: center;
  }

  .everyDayDeals {
    color: #1A1F28;
    font-size: 18px;
    line-height: 15px;
    text-align: center;
  }

  .select-mem-header {
    color: #646768;
    font-size: 14px;
    text-align: center;
    font-weight: bold;
  }

  .exc-add-btn-wrapper {
    text-align: center;
  }

  .exc-modal-footer {
    text-decoration: underline;
    color: #414141;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 6px;
  }

  .ex-modal .price h4 {
    color: rgb(100, 103, 104);
  }

  .ex-title-grey {
    color:  #646769 !important;
  }

  .ex-modal .ex-title-grey {
    color:  rgb(100, 103, 104) !important;
  }

  @media screen and (min-width: 769px) {
    .exc-desktop-header {
      margin: 0px;
    }

    .exc-mobile-header {
      display: none;
    }
  }

  @media screen and (max-width: 768px) {
    .exc-desktop-header {
      display: none;
    }

    .exc-mobile-header {
      margin-bottom: 20px;
    }
  }

  @media screen and (max-width: 991px) {
    ul {
      font-size: 14px;
      margin-bottom: 10px;
    }

    .btn {
      margin-top: 15px;
      margin-bottom: 10px;
    }

    .membership-content h6 {
      font-size: 14px;
    }

    .price h4 {
      font-size: 14px;
      display: block;
      margin-top: 5px;
    }

    .price .price-amount {
      display: block;
    }

    .card {
      max-height: 160px;
    }

    .popular-main {
      padding: 6px 3px;
    }

    .title h5 {
      margin-bottom: 0px;
      font-size: 18px;
    }

    .exc-original-price .og-price {
      font-size: 16px;
    }

    .ex-saving .saving-price {
      font-size: 14px;
    }

    .popular-main {
      font-size: 11px;
    }

    .add-cart-btn {
      font-size: 14px;
      margin-top: 20px !important;
    }

    .month {
      font-size: 10px;
      margin-bottom: 2px;
    }

    .membership-price {
      font-size: 19px;
    }
    .exc-plan-comp2 {
      background: linear-gradient(to bottom, #ff9d8a, #e76a52);
      box-shadow: 0 3px 10px rgb(0 0 0 / 20%);
    }
    .exc-plan-comp2 span{
      color: #fff !important;
    }
    .exc-plan-comp {
      background: #fff;
      box-shadow: 0 3px 10px rgb(0 0 0 / 20%);
      color: #e76a52;
    }
    /* pretty radio */
    label > input[type="radio"] {
      display: none;
    }
    label > input[type="radio"][disabled] + *::before {
      content: "";
      display: inline-block;
      vertical-align: bottom;
      width: 1rem;
      height: 1rem;
      margin-right: 0.3rem;
      border-radius: 50%;
      border-style: solid;
      border-width: 0.1rem;
      border-color: darkgray;
    }
    label > input[type="radio"] + *::before {
      content: "";
      display: inline-block;
      vertical-align: bottom;
      width: 1rem;
      height: 1rem;
      margin-right: 0.3rem;
      border-radius: 50%;
      border-style: solid;
      border-width: 0.145rem;
      border-color: #fff;
    }
    label > input[type="radio"]:checked + * {
      color: #fff;
    }
    label > input[type="radio"]:checked + *::before {
      border-color: #fff; 
      background: #fff;
      cursor: pointer;
      background-clip: content-box;
      padding: 1px;
    }
    .exc-plan-comp label > input[type="radio"] {
      display: none;
    }
    .exc-plan-comp label > input[type="radio"][disabled] + *::before {
      content: "";
      display: inline-block;
      vertical-align: bottom;
      width: 1rem;
      height: 1rem;
      margin-right: 0.3rem;
      border-radius: 50%;
      border-style: solid;
      border-width: 0.1rem;
      border-color: darkgray;
    }
    .exc-plan-comp label > input[type="radio"] + *::before {
      content: "";
      display: inline-block;
      vertical-align: bottom;
      width: 1rem;
      height: 1rem;
      margin-right: 0.3rem;
      border-radius: 50%;
      border-style: solid;
      border-width: 0.145rem;
      border-color: #e76a52;
    }
    .exc-plan-comp label > input[type="radio"]:checked + * {
      color: #e76a52;
    }
    .exc-plan-comp label > input[type="radio"]:checked + *::before {
      border-color: #e76a52; 
      background: #e76a52;
      cursor: pointer;
      background-clip: content-box;
      padding: 1px;
    }
    .plan-rad {
      border-radius: 0.35rem;;
    }
    .fa-angle-down {
      transition: all 0.4s ease;
    }
    .collapsepadding[aria-expanded="true"] .fa-angle-down {
      transform: rotateZ(180deg);
    }
    .colPaddingHiden {
      padding-left: 0 !important;
      padding-right: 0 !important;
      width: 90%;
    }
  }
  @media screen and (max-width: 360px) {
    .title h5 {
      margin-bottom: 0px;
      font-size: 15px;
    }
    membership-price[data-v-97bc3ff6] {
      font-size: 18px;
    }
    .ex-saving .saving-price {
      font-size: 13px;
    }
  }
  @media screen and (max-width: 320px) {
    .card {
      width: 28%;
      margin-bottom: 15px !important;
    }
    .popular-main {
      font-size: 9px;
      max-height: 150px;
    }
    .title h5 {
      font-size: 13px;
    }
    .membership-price {
      font-size: 16px;
    }
    .ex-saving .saving-price {
      font-size: 11px;
    }
    .add-cart-btn {
      margin-top: 5px !important;
    }
  }

  @media screen and (max-width: 991px) {
    .card a {
      padding-top: 4%;
    }
  }
  @media screen and (min-width: 991px) {
    .card {
      height: 210px;
    }
  }
</style>



// WEBPACK FOOTER //
// mainExcDynamicCards.vue?a92f5d54